import Vue from 'vue';
import Router from 'vue-router';
import Store from '@/store';
import {
    setSStorage,
    getSStorage,
    getLStorage,
    judgeMiniApp,
    setToken,
    apiRequest,
    setLStorage,
} from '@/utils/';
import { setUserUniqueId, setMemberTypeName } from '@/utils/finder.js';
import registerWechat from '@/utils/wxEvent';
import { isApp, isIos, isHarmony } from 'atour-jsbridge';
import getQueryVal from '@/utils/getQueryVal';
import { setFinderConfig } from '@/utils/finder';
import Sentry from '@/sentry';
import { getTdBlackbox, tdFpInit } from '@/utils/tdfp';
// 重写路由的push方法(解决webview中场景切换如：跳登陆后回到当前页路由会报错问题)，加catch解决
const routerPush = Router.prototype.push;
const routerReplace = Router.prototype.replace;
Router.prototype.push = function push(location) {
    if (typeof (location) === 'string') {
        var Separator = '&';
        if (location.indexOf('?') === -1) { Separator = '?'; }
        location = location + Separator + 'random=' + Math.random();
    }
    return routerPush.call(this, location).catch(error => error);
};
Router.prototype.replace = function replace(location) {
    return routerReplace.call(this, location).catch(error => error);
};

Vue.use(Router);

console.log(isApp, isIos, isHarmony, 'isApp, isIos, isHarmony--------HHHHHHH');

let routes = [];
// 自动引入路由，新增不需要手动添加
const routerContext = require.context('./', false, /\.js$/);
routerContext.keys().forEach(route => {
    // 如果是根目录的 index.js 、不处理
    if (route.startsWith('./index')) {
        return;
    }
    const routerModule = routerContext(route);
    routes = [...routes, ...(routerModule.default || routerModule)];
});

const routerObj = new Router({
    mode: 'history',
    base: 'hy',
    routes,
});

// Loading Chunk Failed 的错误监听和Fix
routerObj.onError((error) => {
    const jsPattern = /Loading chunk (\S)+ failed/g;
    const cssPattern = /Loading CSS chunk (\S)+ failed/g;
    const isChunkLoadFailed = error.message.match(jsPattern || cssPattern);
    const targetPath = routerObj.history.pending.fullPath;
    if (isChunkLoadFailed) {
        console.log('targetPath', targetPath);
        window.location.reload();
    }
});

const getTokenByTicket = async(queryParam) => {
    if (queryParam?.ticket) {
        const { ticket } = queryParam;
        if (ticket === getLStorage('ticket')) {
            return getLStorage('token');
        }

        const res = await apiRequest('post', '/user/getUserTokenByTicket', { ticket });
        console.log(res, '------apiRequest result----');

        if (res?.result?.token) {
            const { token } = res.result;
            setLStorage('token', token);
            setSStorage('token', token);
            setLStorage('ticket', ticket);
            setSStorage('ticket', ticket);
            return token;
        }
        return '';
    }
    // const
};

routerObj.beforeEach(async(to, from, next) => {
    console.log('--------toquery', to.query);
    const mebId = to.query?.mebId || getLStorage('mebId') || '';
    if (mebId) {
        setUserUniqueId(mebId);
        Sentry.setUser({ id: mebId });
    }
    // 设置标题
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    // 设置来源
    if (to.query.source) {
        setSStorage('source', to.query.source);
    }
    // 获取同盾指纹
    if (!getTdBlackbox()) {
        tdFpInit();
    }
    // ============ 统一校验token ==========
    const sToken = getSStorage('token'); // 缓存token
    const qToken = getQueryVal('card_no') || getQueryVal('token'); // url附带token
    const utm_source = getQueryVal('utm_source');
    if (utm_source) {
        setFinderConfig({
            utm_source,
        });
    }
    let tValue = '';
    if ((sToken && qToken && sToken !== qToken) || (!sToken && qToken)) {
        // 1、有两个token但不一致
        // 2、只有url附带token，缓存token并重置埋点的公用参数
        tValue = qToken;
        setToken(tValue);
    } else if (to.query.card_no || to.query.token) {
        // 设置session、store
        setToken(to.query.card_no || to.query.token);
    }
    // ============ 统一校验token ==========
    if (to.query.token === '') {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
    }
    // Store.state.token = getSStorage('token') || getLStorage('token');
    // Store.commit('setToken', getLStorage('token') || getSStorage('token'));
    if (!getSStorage('platType')) {
        // 设置渠道
        await judgeMiniApp().then(({
            type,
        }) => {
            if (type === 'wechat') { // 微信小程序
                setSStorage('platType', 6);
            } else if (type === 'alipay') { // 支付宝小程序
                setSStorage('platType', 13);
            } else if (type === 'tt') {
                const ua = window.navigator.userAgent.toLowerCase();
                if (ua.indexOf('newsarticle') !== -1) { // 头条
                    setSStorage('platType', 16);
                } else if (ua.indexOf('aweme') !== -1) { // 抖音
                    setSStorage('platType', 15);
                } else { // 火山或其他
                    setSStorage('platType', 17);
                }
            } else if (type === 'xiaoHongShu') { // 小红书浏览器
                setSStorage('platType', 19);
            }
        }).catch((type) => {
            // 在APP内
            if (isApp()) {
                // ios
                if (isIos()) {
                    setSStorage('platType', 2);
                } else { // 安卓
                    if (isHarmony) {
                        setSStorage('platType', 25);
                    } else {
                        setSStorage('platType', 1);
                    }
                }
            } else if (type === 'wechat') { // 微信浏览器
                setSStorage('platType', 3);
            } else { // 在浏览器内
                setSStorage('platType', 5);
            }
        });
    }
    // ============ 统一校验token ==========
    const tokenByticket = await getTokenByTicket(to.query);
    tValue = tokenByticket;
    Store.commit('setToken', getLStorage('token') || getSStorage('token'));
    if (tValue) {
        try {
            // hideToast=true，接口异常时，apiRequest不报错
            const { result } = await apiRequest('get', '/user/getUserCenterInfo', {}, { hideToast: true });
            if (result?.personalInfo) {
                const mebId = result.personalInfo.mebId;
                setUserUniqueId(mebId); // 重置埋点的公用参数
                Sentry.setUser({ id: mebId });
                setMemberTypeName(result.personalInfo.mebType); // 重置埋点的公用参数
                Store.commit('setUserInfo', result.personalInfo); // 存储用户信息
            }
            console.log('getUserCenterInfo 接口正常 result=', result);
        } catch (error) {
            console.log('getUserCenterInfo 接口异常 error=', error);
        }
    }
    // ============ 统一校验token ==========
    // 判断是否不需要持久化保持登陆状态
    if (to.meta.singlePageLogin) {
        const token = getLStorage('token');
        if (token) {
            setSStorage('token', token);
            localStorage.removeItem('token');
        }
    }
    // 设置渠道
    if (to.query.activitySource) {
        setSStorage('activitySource', to.query.activitySource);
    }
    // 设置活动ID
    if (to.query.activeId) {
        setSStorage('activeId', to.query.activeId);
    }
    // 设置活动ID
    if (to.query.activityId) {
        setSStorage('activityId', to.query.activityId);
    }
    // 设置上一页缓存
    setSStorage('preRouter', JSON.stringify({
        path: from.path,
        name: from.name,
        query: from.query,
        params: from.params,
    }));
    // n+1会员卡需求，首页跳转到详情之后滚动条置顶
    if (to.path === '/activity/CoBrandCrad/detail') {
        const domTop = document.querySelector('.app-contain');
        if (domTop !== null) {
            document.querySelector('.app-contain').scrollTop = 0;
        }
    }
    if (!Store.state.userInfo) {
        Store.dispatch('fetchUserInfo');// 存储用户信息
    }
    // 前往下一页
    next();
    if (to.meta.wxConfig) {
        registerWechat(to.meta.wxConfig, to.path);
    }
});
export default routerObj;
